module.exports = __webpack_public_path__ + "img/hobbiton-3018-09-22.13611340.jpg";